import { animate, style, transition, trigger } from "@angular/animations";
import { Component, Input, ViewChild } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import dateFormat, { masks } from "dateformat";
import pdfMake from "pdfmake/build/pdfmake.min";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { formatDate, formatNumber } from "@angular/common";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import html2canvas from "html2canvas";
import Swal from "sweetalert2";
import { data } from "jquery";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { DomSanitizer } from "@angular/platform-browser";
import { date } from "ngx-custom-validators/src/app/date/validator";
import { AmdReportService } from "../amd-report/amd-report.service";
import { MEntity } from "../master/mEntity";
import { environment } from "src/environments/environment";
import { Console } from "console";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { SubCatgeoryJsonData } from "../amd-report/equipment-management/be-registration/Models/SubCategoryData.model";
import { AMDService } from "../AMD/amd-service";

export interface dataListHead {
  name: string;
  dataKey: string;
  displayColumn: boolean;
  sortDirection: "" | "asc" | "desc";
  filterKey: any;
  sticky?: "start" | "end" | "none";
  static: boolean;
}

@Component({
  selector: "beinfo-detail",
  templateUrl: "./beInfoDetail.component.html",
  styleUrls: ["./beInfoDetail.component.scss"],
  animations: [
    trigger("slideInOutLeft", [
      transition(":enter", [
        style({ transform: "translateX(100%)" }),
        animate("300ms ease-in", style({ transform: "translateX(0%)" })),
      ]),
      transition(":leave", [
        animate("300ms ease-in", style({ transform: "translateX(100%)" })),
      ]),
    ]),
    trigger("slideInOutRight", [
      transition(":enter", [
        style({ transform: "translateX(-100%)" }),
        animate("300ms ease-in", style({ transform: "translateX(0%)" })),
      ]),
      transition(":leave", [
        animate("300ms ease-in", style({ transform: "translateX(-100%)" })),
      ]),
    ]),
  ],
  providers: [DatePipe],
})
export class BeInfoDetail {
  @Input() tableDatas: Array<any> = [];
  @Input() tableDatasOriginal: Array<any> = [];
  @Input() beNumberData;

  @ViewChild("deactive") deactive: any;
  @ViewChild("add") add: any;
  // @Input() accesoriesData;

  public accesoriesData: any;
  public page = 1;
  public pageSize = 10;
  public page2 = 1;
  public pageSize2 = 10;
  public page6 = 1;
  public pageSize6 = 10;
  public page7 = 1;
  public pageSize7 = 10;
  public totalPageSize = 0;
  public addSelectorToggle: boolean;
  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  // public disableTable: Boolean;
  public maintenanceInfo: boolean = true;
  public dateInfo: boolean = true;
  public rentalInfo: boolean = false;
  public purchaseInfo: boolean = false;
  public statutoryInfo: boolean = false;

  public loading: Boolean = true;
  public noRecord: Boolean = false;
  public sectionEnable: Boolean = false;
  public sectionEnableDetails: Boolean = false;
  lastSelectorToggle: boolean = true;
  public dataList: any = [];
  dropdownListActive: string[];
  // benumbernew:any = []
  selectedGroup: any;
  editSelectToggle: boolean;
  viewSelectToggle: boolean;
  editList: any;
  viewList: any;
  addList: any;
  assetGroup: any;
  dataListHead: any;
  Active: any = "Y";
  blurStyle: string;
  background: boolean;
  // beNumberData: any;
  // beNumberData: any;
  sshTableDatas: any;
  workGroupName: string;
  assetCategoryName: string;
  sphTableDatas: any;
  newTables1: any[];
  newTables: any[];
  locationhistory: any[];
  public firstBack: Boolean;
  public cardVisibility: Boolean;
  beNumberImage: any;
  sparesHistoryDataOld: any = [];
  accesoriesDataStandardComponents: any;
  subSubCategoryFlag: boolean;
  oldSubSubCategoryData: boolean;
  serviceHistoryData: any = [];
  sparesHistoryData: any;
  mrHistoryData: any;
  serviceHistoryDataOld: any = [];
  loanEquipmentStatus: any;
  testEquipmentStatus: any;
  serviceHistoryBtn: boolean = false;
  sparesHistoryBtn: boolean = false;
  fileChecing: any;
  fileChecingInt: any;
  benumbernew: any = [];
  // oldBe:boolean=true
  constructor(
    private amdService: AmdReportService,
    private mEntity: MEntity,
    private _sanitizer: DomSanitizer,
    private toasterService: ToastrService,
    private datePipe: DatePipe,
    private subSubCategory: SubCatgeoryJsonData,
    private amdServiceNew: AMDService
  ) {
    this.sphTableDatas = [
      {
        id: "1",
        validatedDateZm: "MRE146970",
        validatedByZm: "20/07/2018",
        beGroup: "25/07/2018",
        beGroupDescription: "PR122361",
        beCode: "25/07/2018",
        actionCode: "RFQ",
        faultCode: "25/07/2018",
        pretorfq: "25/07/2018",
        poNo: "PO114271",
        poDate: "03/08/2018",
        poStatus: "Closed",
        grnDate: "14/09/2018",
      },
      {
        id: "2",
        validatedDateZm: "MRE126862",
        validatedByZm: "30/03/2017",
        beGroup: "04/04/2017",
        beGroupDescription: "PR114777",
        beCode: "06/04/2017",
        actionCode: "RFQ",
        faultCode: "07/04/2017",
        pretorfq: "14/04/2017",
        poNo: "PO108955",
        poDate: "18/04/2017",
        poStatus: "Closed",
        grnDate: "19/04/2017",
      },
    ];
  }

  public ebeAccessoriesFLag: boolean = false;
  public sparesCurrentFlag: boolean = true;
  public sparesOldFlag: boolean = false;
  public serviceCurrentFlag: boolean = true;
  public serviceOldFlag: boolean = false;
  vs2SNFFilePath: string;
  vs2SNFFilePathInt: string;
  vs4FilePath: string;
  vs4FilePathInt: string;
  fileCard1Flag: boolean;
  fileCard1FlagInt: boolean;
  fileCard2Flag: boolean;
  fileCard2FlagInt: boolean;
  fileChecingtwoInt: any;

  public serviceApiUrl: any;
  beNumberHistoryList:any=[]
  fileChecingtwo: any;
  userName: string;
  currentUser: any;
  userDetails: any;
  serviceHistoryDataOldInit: any = [];
  sparesHistoryDataOldInit: any = [];
  //
  accDataList: any[];
  accDataListAdd: any[];
  public ebeFlag: Boolean = false;
  beCodeAndMAnufacturer: any;
  manufactureArray:any[]

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.userDetails = this.currentUser.userDetails[0];
    this.userName = this.currentUser.name;

    this.dataListHead = [
      {
        name: "WR Number ",
        dataKey: "wrNumber",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "WR Date & Time",
        dataKey: "wrDateTime",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: true,
      },
      {
        name: "WO Number",
        dataKey: "woNumber",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "WO Date & Time",
        dataKey: "woDateTime",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: true,
      },
      {
        name: "Problem Reported",
        dataKey: "problemReported",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Action Taken",
        dataKey: "actionTaken",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: true,
      },
      {
        name: "WO Completed Date & Time",
        dataKey: "completionDateTime",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: true,
      },
      {
        name: "Engineer Name",
        dataKey: "assignTo",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Material Cost",
        dataKey: "materialCost",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: true,
      },
    ];
    //
    this.accDataList = [
      {
        name: "BE Number",
        dataKey: "tassetObj.beNumber + beNumberConCat[i]",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "BE Code",
        dataKey: "datas.beCodeSub",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "BE Category",
        dataKey: "datas.subCategoryName",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "General Name",
        dataKey: "generalName[i]",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      // {
      //   name: "Work Group",
      //   dataKey: "Dental",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "Ownership",
      //   dataKey: "Accessories",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "Purchase Cost",
      //   dataKey: "purchaseCost[i]",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "BE Conditional Status",
      //   dataKey: "ACT",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      
      // {
      //   name: "Manufacturer",
      //   dataKey: "data.manufacturerName",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "Model",
      //   dataKey: "data.modelNumber",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "Serial Number",
      //   dataKey: "FILTER",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "JKKP Certificate No",
      //   dataKey: "",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "Statutory Expiry Date",
      //   dataKey: "statutoryExpiryDate",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      // {
      //   name: "Availability",
      //   dataKey: "FILTER",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
    ];
    this.accDataListAdd = [
      {
        name: "BE Number",
        dataKey: "tassetObj.beNumber + beNumberConCat[i]",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "BE Code",
        dataKey: "datas.beCodeSub",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "BE Category",
        dataKey: "datas.subCategoryName",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "General Name",
        dataKey: "generalName[i]",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Work Group",
        dataKey: "Dental",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Ownership",
        dataKey: "Accessories",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Purchase Cost",
        dataKey: "purchaseCost[i]",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "BE Conditional Status",
        dataKey: "ACT",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      // {
      //   name: "BE Status",
      //   dataKey: "FILTER",
      //   displayColumn: true,
      //   sortDirection: "",
      //   static: true,
      //   anchorTag: false,
      // },
      {
        name: "Manufacturer",
        dataKey: "data.manufacturerName",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Model",
        dataKey: "data.modelNumber",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
      {
        name: "Serial Number",
        dataKey: "FILTER",
        displayColumn: true,
        sortDirection: "",
        static: true,
        anchorTag: false,
      },
     
    ];
    this.amdServiceNew.fetchAllManufacture().subscribe((x:any) => {
      this.manufactureArray = []
      this.manufactureArray = x
      console.log(x)

    })
    // this.cardVisibility = false;
    // this.amdService.fetchByBeNumber(this.beNumberData).subscribe((x) => {
    //     console.log('sevice fetch benumber details', x)
    //     this.beNumberData = x
    // console.log("this", this.beNumberData.assetDescription.ownership.ownershipName)
    //   });
    this.fileChecing = {};
    this.serviceApiUrl = environment.serviceApiUrl;
    this.fileChecingtwo = {};

    console.log("Check the beNumberData :  :  : : : ", this.beNumberData);

    this.amdService.fetchByBeNumber(this.beNumberData).subscribe((x) => {
      console.log("sevice fetch benumber details", x);
      this.beNumberData = x;
      this.amdService.fetchBENumberHistory(this.beNumberData.id).subscribe((y) => {
        if (y.length === 0) {
          this.amdService.fetchOldBeNumberHistory(this.beNumberData.id).subscribe((oldHistory) => {
            this.beNumberHistoryList = oldHistory;
          });
        } else {
          this.beNumberHistoryList = y;
        }
      });
      
      console.log(x)
      console.log(this.beNumberData.id)
      this.onItemSelectCategory();
      console.log(
        "categoryId",
        this.beNumberData.assetDescription.assetCategory.id
      );
      this.amdService
        .fetchBENumberImage(this.beNumberData.assetDescription.assetCategory.id)
        .subscribe((y: any) => {
          this.beNumberImage = y;
          // console.log('Image', this.beNumberImage)
          // this.beNumberImage = this._sanitizer.bypassSecurityTrustResourceUrl(x);
          //   this.beNumberImage = this.mEntity.assetImage;
        });
      this.amdService
        .fetchBENumberLoanEqui(
          this.beNumberData.assetDescription.assetCategory.id
        )
        .subscribe((x) => {
          this.loanEquipmentStatus = x;

          console.log("loanEquipmentStatus", x);
        });
      this.amdService
        .fetchBENumberTestEqui(
          this.beNumberData.assetDescription.assetCategory.id
        )
        .subscribe((x) => {
          this.testEquipmentStatus = x;
          console.log("loanEquipmentStatus", x);
        });
    });
    
    this.amdService
      .fetchBENumberServiceHistoryOld(this.beNumberData)
      .subscribe((x: any) => {
        // this.serviceHistoryBtn = true;
        this.loading = true;
        // this.noRecord = false;
        // this.serviceCurrentFlag = false;
        // this.serviceOldFlag = true;
        this.serviceHistoryDataOldInit = x;
        // console.log("next...",x)
        //  this.serviceHistoryDataOld.sort((a, b) => new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime());
        this.loading = false;
        // this.noRecord = true;
        // console.log("serviceHistory", x);
      });
    this.amdService
      .fetchBENumberMaterialHistorydata(this.beNumberData)
      .subscribe((x: any) => {
        console.log(this.benumbernew, "x");
        this.benumbernew = x;
      });

    this.accesoriesData = [];
    this.accesoriesDataStandardComponents = [];
    this.serviceHistoryData = [];
    this.sparesHistoryData = [];
    this.mrHistoryData = [];
    this.sparesHistoryDataOld = [];
    this.serviceHistoryDataOld = [];
    console.log("watgoes", this.beNumberData);
    this.amdService
      .fetchBENumberServiceHistoryCurrent(this.beNumberData)
      .subscribe((x: any) => {
        this.loading = true;
        this.noRecord = false;
        this.serviceCurrentFlag = true;
        this.serviceOldFlag = false;
        this.serviceHistoryData = x;
        console.log("new", x);
        this.serviceHistoryData.sort(
          (a, b) =>
            new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime()
        );
        this.loading = false;
        this.noRecord = true;
        console.log("serviceHistory", x);
      });
    this.amdService
      .fetchBENumberSparesHistoryCurrent(this.beNumberData)
      .subscribe((x: any) => {
        this.sparesCurrentFlag = true;
        this.sparesOldFlag = false;
        this.loading = true;
        this.noRecord = false;
        this.sparesHistoryData = x.filter((obj) => obj.woNumber != "");
        this.sparesHistoryData.sort(
          (a, b) =>
            new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime()
        );
        console.log("spare", this.sparesHistoryData);
        this.loading = false;
        this.noRecord = true;
        console.log("sparesHistoryCurrent", x);
      });

    this.amdService
      .fetchBENumberSparesHistoryPrevious(this.beNumberData.beNumber)
      .subscribe((x: any) => {
        // this.sparesHistoryBtn = true;
        // this.sparesCurrentFlag = false;
        // this.sparesOldFlag = true;
        this.loading = true;
        // this.noRecord = false;
        this.sparesHistoryDataOldInit = x.filter((obj) => obj.woNumber != "");
        // this.sparesHistoryDataOldInit.sort((a, b) => new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime())
        this.loading = false;
        // this.noRecord = true;
        console.log("sparesHistoryOld", x);
      });

    this.amdService
      .fetchBENumberAccesories(this.beNumberData)
      .subscribe((x: any) => {
        this.accesoriesData = x;
        this.accesoriesData.sort((a: any, b: any) => {
           // Sort by isActive ('Y' comes first)
        if (a.isActive === 'Y' && b.isActive === 'N') return -1;
        if (a.isActive === 'N' && b.isActive === 'Y') return 1;

          console.log("lastTable", this.tableDatas);
          const aAlphaNum: string[] = a.beNumber.split(/(\d+)/);
          const bAlphaNum: string[] = b.beNumber.split(/(\d+)/);

          for (
            let i = 0;
            i < Math.max(aAlphaNum.length, bAlphaNum.length);
            i++
          ) {
            if (aAlphaNum[i] !== bAlphaNum[i]) {
              if (
                isNaN(parseInt(aAlphaNum[i])) ||
                isNaN(parseInt(bAlphaNum[i]))
              ) {
                // Compare non-digit parts alphabetically
                return aAlphaNum[i].localeCompare(bAlphaNum[i]);
              } else {
                // Compare digit parts numerically
                return parseInt(aAlphaNum[i]) - parseInt(bAlphaNum[i]);
              }
            }
          }

          return 0;
        });
        console.log("stat", x);
        this.subSubCategoryFlag = true;
        this.oldSubSubCategoryData = true;
        if (x.length == 0) {
          // this.amdService.fetchAllSubCategoryDatas(this.beNumberData).subscribe((z : any) => {
          //   // console.log("fetched table datas sub category", x);
          //   this.accesoriesData = [];
          //   this.accesoriesData = z;
          //   this.subSubCategoryFlag = false;
          // })
          this.amdService
            .fetchAllAssetSecondarySubCategoryDatas(this.beNumberData)
            .subscribe((y: any) => {
              this.accesoriesData = [];
              this.accesoriesData = y;
              console.log("y",y)
              console.log("y",this.accesoriesData)
              this.accesoriesData.sort((a: any, b: any) => {

                if (a.isActive === 'Y' && b.isActive === 'N') return -1;
                if (a.isActive === 'N' && b.isActive === 'Y') return 1;

                console.log("lastTable", this.tableDatas);
                const aAlphaNum: string[] = a.beNumber.split(/(\d+)/);
                const bAlphaNum: string[] = b.beNumber.split(/(\d+)/);

                for (
                  let i = 0;
                  i < Math.max(aAlphaNum.length, bAlphaNum.length);
                  i++
                ) {
                  if (aAlphaNum[i] !== bAlphaNum[i]) {
                    if (
                      isNaN(parseInt(aAlphaNum[i])) ||
                      isNaN(parseInt(bAlphaNum[i]))
                    ) {
                      // Compare non-digit parts alphabetically
                      return aAlphaNum[i].localeCompare(bAlphaNum[i]);
                    } else {
                      // Compare digit parts numerically
                      return parseInt(aAlphaNum[i]) - parseInt(bAlphaNum[i]);
                    }
                  }
                }

                return 0;
              });
              this.subSubCategoryFlag = false;
              this.oldSubSubCategoryData = false;
              // y.forEach(element => {
              //   console.log(element)
              //   element.beNumber = element.beNumber;
              //   element.assetDescription.assetCategory.beCategoryName = element.assetCategoryName;
              //   element.assetDescription.assetConditionalStatus.assetStatusCode = element.beConditionalStatus
              //   element.assetManufacturerDetail.manufacturer.manufacturerName = element.manufacturerNameFromBeCodeManufacturer
              //   element.assetManufacturerDetail.modelName = element.modelNumberName
              //   element.assetFinancial.assetFinancialDetail.serialNumber = element.serialNumber
              //   element.assetFinancial.assetFinancialDetail.purchaseCost = element.purchaseCost
              //   this.accesoriesData.push(element);
              // });
              // this.accesoriesData = y;
            });
        }
      });
    this.amdService
      .fetchByBeNumberFromStandardComponentsDatas(this.beNumberData)
      .subscribe((y) => {
        this.accesoriesDataStandardComponents = y;
      });

    this.newTables1 = [
      // {no:'1',start:'21-11-2019',validate:'20-11-2019',be:'ACT',new:'DEA',status:'Not Functioning',change:'User Requested',doc:'Download'},
      // {no:'2',start:'14-12-2019',validate:'13-12-2019',be:'DEA',new:'ACT',status:'Functioning',change:'User Requested',doc:'Download'},
    ];
    this.sshTableDatas = [
      {
        id: "1",
        validatedDateZm: "PWO319881",
        validatedByZm: "01/03/2018",
        beGroup: "29/05/2018",
        beGroupDescription: "Schedule maintenance for Amalgamators",
        beCode: "PPM DONE AS PER CHECKLIST",
        actionCode: "STK107352",
        faultCode: "1,087.00",
      },
      {
        id: "2",
        validatedDateZm: "PWO319882",
        validatedByZm: "04/05/2018",
        beGroup: "12/07/2018",
        beGroupDescription: "SPO2 TIDAK BOLEH DETECT",
        beCode: "Replaced new sensor,tested ok",
        actionCode: "STK106867",
        faultCode: "220.00",
      },
    ];
    this.locationhistory = [
      // {id:'1',start:'21-11-2019',date:'20-11-2019',old:'WKL710',name:'Klinik KOmuniti Raya Permai',district:'LEMBAH PANTAI',code:'WKL002',clinic:'Klinik Kesihatan Batu',dst:'LEMBAH PANTAI',category:'BE Not Used',doc:'Download'},
      // {id:'2',start:'21-11-2019',date:'20-11-2019',old:'WKL002',name:'Klinik Kesihatan Batu',district:'LEMBAH PANTAI',code:'WKL104',clinic:'Klinik Pergigian Cahaya Suria',dst:'LEMBAH PANTAI',category:'Clinic Closed',doc:'Download'}
    ];
    

    // this.beNumberData = data.beNumberData;

    // console.log(data.beNumberData,'be number when clicked')

    this.amdService
      .fetchBENumberConditionalStatus(this.beNumberData)
      .subscribe((x) => {
        // this.conditionalStatus = x[0];
        this.conditionalStatus = x;
        console.log("conditionalCheck", x);
      });

    this.amdService
      .fetchBENumberLocationChange(this.beNumberData)
      .subscribe((x) => {
        // let data: any = x;

        // this.locationStatus = data[data.length - 1];
        this.locationStatus = x;

        console.log("locationCheck", x);
      });
    this.lastSelectorToggle = true;
    // this.cardVisibility = true

    // for Internal Var file
    this.amdService.fetchByInternalVs2File(this.beNumberData).subscribe((x) => {
      this.fileChecingInt = x;

      let var1FilePathIdInt = this.fileChecingInt?.multipleFileUpload.find(
        (obj) => obj?.fileKey == "Kewpa15File"
      )?.id;
      this.vs2SNFFilePathInt =
        this.serviceApiUrl +
        "mutipleFileUpload/downladFileById?id=" +
        var1FilePathIdInt;
      this.fileCard1FlagInt =
        this.fileChecingInt?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "Kewpa15File"
        ) != null;
    });
    this.amdService.fetchByInternalVs4File(this.beNumberData).subscribe((x) => {
      this.fileChecingtwoInt = x;
      console.log("file checking from var to external ", x);

      let vs4FilePathIdInt = this.fileChecingtwoInt?.multipleFileUpload.find(
        (obj) => obj?.fileKey == "InternalVariationV1S4SupportingDocument"
      )?.id;
      this.vs4FilePathInt =
        this.serviceApiUrl +
        "mutipleFileUpload/downladFileById?id=" +
        vs4FilePathIdInt;
      this.fileCard2FlagInt =
        this.fileChecingtwoInt?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "InternalVariationV1S4SupportingDocument"
        ) != null;
    });

    // for files

    this.amdService
      .fetchByBeNumberInfoFile(this.beNumberData)
      .subscribe((x) => {
        this.fileChecing = x;

        let var1FilePathId = this.fileChecing?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "serviceNotificationFormFile"
        )?.id;
        this.vs2SNFFilePath =
          this.serviceApiUrl +
          "mutipleFileUpload/downladFileById?id=" +
          var1FilePathId;
        this.fileCard1Flag =
          this.fileChecing?.multipleFileUpload.find(
            (obj) => obj?.fileKey == "serviceNotificationFormFile"
          ) != null;
      });
    this.amdService
      .fetchByBeNumberInfoFiletwo(this.beNumberData)
      .subscribe((x) => {
        this.fileChecingtwo = x;
        console.log("file checking from var to external ", x);

        let vs4FilePathId = this.fileChecingtwo?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "varVs4File"
        )?.id;
        this.vs4FilePath =
          this.serviceApiUrl +
          "mutipleFileUpload/downladFileById?id=" +
          vs4FilePathId;
        this.fileCard2Flag =
          this.fileChecingtwo?.multipleFileUpload.find(
            (obj) => obj?.fileKey == "varVs4File"
          ) != null;
      });
    // Below Code this for Internal Var-Process file download
    // this.amdService.fetchByInternalVs2File(this.beNumberData).subscribe((x) => {
    //   this.fileChecing =x
    //   console.log("file checking from var to internal ",x)

    //   let var1FilePathId = this.fileChecing?.multipleFileUpload.find(obj => obj?.fileKey == "Kewpa15File")?.id
    //   this.vs2SNFFilePath = this.serviceApiUrl + "mutipleFileUpload/downladFileById?id=" + var1FilePathId;
    //   this.fileCard1Flag = this.fileChecing?.multipleFileUpload.find(obj => obj?.fileKey == "Kewpa15File") != null

    //   })
    //   this.amdService.fetchByInternalVs4File(this.beNumberData).subscribe((x) => {
    //     this.fileChecing =x
    //     console.log("file checking from var four ",x)
    //     let var1FilePathId = this.fileChecing?.multipleFileUpload.find(obj => obj?.fileKey == "InternalVariationV1S4SupportingDocument")?.id
    //     this.vs2SNFFilePath = this.serviceApiUrl + "mutipleFileUpload/downladFileById?id=" + var1FilePathId;
    //     this.fileCard1Flag = this.fileChecing?.multipleFileUpload.find(obj => obj?.fileKey == "InternalVariationV1S4SupportingDocument") != null

    //     })

    // this.amdService.fetchBENumberServiceHistoryOld(this.beNumberData).subscribe((x: any) => {
    //   // this.serviceHistoryBtn = true;
    //   // this.loading = true;
    //   // this.noRecord = false;
    //   // this.serviceCurrentFlag = false;
    //   // this.serviceOldFlag = true;

    //   this.serviceHistoryDataOld = x;
    //   console.log("old",x)
    //  this.serviceHistoryDataOld.sort((a, b) => new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime());
    //   // this.loading = false;
    //   // this.noRecord = true;
    //   console.log("serviceHistory", x);
    // });
    // this.amdService
    // .fetchBENumberSparesHistoryPrevious(this.beNumberData)
    // .subscribe((x: any) => {
    //   // this.sparesHistoryBtn = true;
    //   // this.sparesCurrentFlag = false;
    //   // this.sparesOldFlag = true;
    //   // this.loading = true;
    //   // this.noRecord = false;
    //   this.sparesHistoryDataOld = x.filter((obj) => obj.woNumber != "");
    //   // this.loading = false;
    //   // this.noRecord = true;
    //   console.log("sparesHistoryOld", x);
    // });
  }
  mrNumber: any;
  beNumber: any;

  // clickBE(beNumber: number) {
  //   this.oldBe = !this.oldBe;
  //   this.beNumberData.beNumber = beNumber;
  
   
  // }
  

  selectedMR(data) {
    console.log("mrinfo", this.beNumberData);

    this.mrNumber = data.mrNumber;
    this.amdService
      .fetchBENumberMaterialHistory(this.beNumberData.beNumber, this.mrNumber)
      .subscribe((x: any) => {
        this.mrHistoryData = x;
        console.log("serviceHistory", x);
      });
  }

  oldYearDataSpares() {
    this.amdService
      .fetchBENumberSparesHistoryPrevious(this.beNumberData.beNumber)
      .subscribe((x: any) => {
        this.sparesHistoryBtn = true;
        this.sparesCurrentFlag = false;
        this.sparesOldFlag = true;
        this.loading = true;
        this.noRecord = false;
        this.sparesHistoryDataOld = x.filter((obj) => obj.woNumber != "");
        this.sparesHistoryDataOld.sort(
          (a, b) =>
            new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime()
        );
        this.loading = false;
        this.noRecord = true;
        console.log("sparesHistoryOld", x);
      });
  }
  oldYearDataService() {
    this.amdService
      .fetchBENumberServiceHistoryOld(this.beNumberData.beNumber)
      .subscribe((x: any) => {
        this.serviceHistoryBtn = true;
        this.loading = true;
        this.noRecord = false;
        this.serviceCurrentFlag = false;
        this.serviceOldFlag = true;
        this.serviceHistoryDataOld = x;
        console.log("next...", x);
        this.serviceHistoryDataOld.sort(
          (a, b) =>
            new Date(b.woDateTime).getTime() - new Date(a.woDateTime).getTime()
        );
        this.loading = false;
        this.noRecord = true;
        console.log("serviceHistory", x);
      });
  }
  goBack($event: any) {
    // window.location.reload();
    this.lastSelectorToggle = false;
    console.log("refresh event ", $event, this.beNumber);
  }
  clickFunServiceHistory() {
    // this.sparesHistoryData =[]
    console.log("Servicce.........", this.sparesHistoryData);
  }
  clickFun() {
    // this.serviceHistoryData =[]
    console.log("Spare.........", this.serviceHistoryData);
  }
  // ngOnChanges() {
  //   if (this.beNumberData) {
  //     this.ngOnInit();
  //     this.sparesHistoryBtn = false;
  //     this.serviceHistoryBtn = false;
  //   }
  // }
  refreshData() {
    // this.beNumberData = '';
  }
  conditionalStatus: any;
  // accesoriesData:any;
  locationStatus: any;
  //   disableTable2() {
  //       this.accesoriesData = [];
  //       this.newTables1=[
  //         // {no:'1',start:'21-11-2019',validate:'20-11-2019',be:'ACT',new:'DEA',status:'Not Functioning',change:'User Requested',doc:'Download'},
  //         // {no:'2',start:'14-12-2019',validate:'13-12-2019',be:'DEA',new:'ACT',status:'Functioning',change:'User Requested',doc:'Download'},

  //       ]
  //       this.sshTableDatas = [
  //         {
  //           id:'1',
  //           validatedDateZm:'PWO319881',
  //           validatedByZm:'01/03/2018',
  //           beGroup:'29/05/2018',
  //           beGroupDescription:'Schedule maintenance for Amalgamators',
  //           beCode:'PPM DONE AS PER CHECKLIST',
  //           actionCode:'STK107352',
  //           faultCode:'1,087.00',

  //         },
  //         {
  //           id:'2',
  //           validatedDateZm:'PWO319882',
  //           validatedByZm:'04/05/2018',
  //           beGroup:'12/07/2018',
  //           beGroupDescription:'SPO2 TIDAK BOLEH DETECT',
  //           beCode:'Replaced new sensor,tested ok',
  //           actionCode:'STK106867',
  //           faultCode:'220.00',
  //         },
  //       ];
  //       this.locationhistory=[
  //         // {id:'1',start:'21-11-2019',date:'20-11-2019',old:'WKL710',name:'Klinik KOmuniti Raya Permai',district:'LEMBAH PANTAI',code:'WKL002',clinic:'Klinik Kesihatan Batu',dst:'LEMBAH PANTAI',category:'BE Not Used',doc:'Download'},
  //         // {id:'2',start:'21-11-2019',date:'20-11-2019',old:'WKL002',name:'Klinik Kesihatan Batu',district:'LEMBAH PANTAI',code:'WKL104',clinic:'Klinik Pergigian Cahaya Suria',dst:'LEMBAH PANTAI',category:'Clinic Closed',doc:'Download'}

  //       ]

  //       // this.beNumberData = data.beNumberData;

  //       // console.log(data.beNumberData,'be number when clicked')

  //       this.amdService.fetchByBeNumber(this.beNumberData).subscribe((x) => {
  //         console.log('sevice fetch benumber details',x)
  //         this.beNumberData = x;
  //       });
  //       this.amdService.fetchBENumberConditionalStatus(this.beNumberData).subscribe((x) => {
  //         console.log(this.amdService.fetchBENumberConditionalStatus,"ACTDEACT")
  //         this.conditionalStatus = x[0];
  //         // console.log('conditionalCheck',x)
  //     })
  //
  //   this.amdService.fetchBENumberLocationChange(this.beNumberData).subscribe((x) => {
  //     this.locationStatus = x[0];

  //     console.log('locationCheck',x)
  // })
  //       this.lastSelectorToggle = true;
  //       // this.cardVisibility = true

  //   }

  sortByDataKey(dataKey: any, sortDirection: any) {
    this.dataListHead.forEach((col) => {
      if (col.dataKey == dataKey) {
        col.sortDirection =
          sortDirection == "" ? "asc" : sortDirection == "asc" ? "desc" : "asc";
      } else {
        col.sortDirection = "";
      }
    });
    sortDirection =
      sortDirection == "" ? "asc" : sortDirection == "asc" ? "desc" : "asc";
    this.serviceHistoryData.sort(this.dynamicSort(dataKey, sortDirection));
  }
  dynamicSort(property: any, sortDirection: any) {
    var sortOrder = 1;
    if (sortDirection == "desc") {
      sortOrder = -1;
    }
    return function (a: any, b: any) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  submitDeactive() {
    
    const selectedItems = this.deAccessoriesList.filter((item) => item.flag === "Y")

    if(selectedItems.length==0){
      Swal.fire("","Kindly Select any Accessories","error")
      return;
    }
    // let beNumberDatas = selectedItems.map((obj)=> obj = obj.beNumber)
    let names = selectedItems.map(item =>item.beNumber);
      
    
      this.amdServiceNew
        .fetchDeactiveBeInfo(names)
        .subscribe((response: any) => {
         
          this.accessoriesFun()
          Swal.fire("", "Accessories Deactivate Successfully", "success");
          this.deactive.hide();
        },
      (error:any)=>{
        if(error.status === 400){
          Swal.fire("", error.error, "error");
        }
      });
    
  }
  dummyCheckBoxValue: any;

  subSubCategoryList: any = [];
   deAccessoriesList:any=[]
  deactivedAcc() {
    let listData = this.accesoriesData.filter(obj=>obj.isActive == 'Y')
    this.deAccessoriesList=[]
    listData.forEach((e)=>{
      let obj={...e}
      this.deAccessoriesList.push(obj)

      
    })


    
  }
  // 
  subSubCategoryListAdd:any=[]
  addAcessListArray :any=[]
  addAcc() {
    // this.addAcessListArray = this.accesoriesData

    let list = this.accesoriesData.filter(obj=>obj.isActive=='N')
    const uniqueList = list.filter((item, index, self) => index === self.findIndex((i) => i.beNumber === item.beNumber) );

    this.addAcessListArray = []
    uniqueList.forEach((e)=>{
      let obj={...e}
      this.addAcessListArray.push(obj)
    })


   
  }
  accessoriesFun() {
    this.amdService
      .fetchBENumberAccesories(this.beNumberData.beNumber)
      .subscribe((x: any) => {
        this.accesoriesData = x;
  
        // Sort by isActive first (Y comes before N), then by beNumber
        this.accesoriesData.sort((a: any, b: any) => {
          // Sort by isActive ('Y' comes first)
          if (a.isActive === 'Y' && b.isActive === 'N') return -1;
          if (a.isActive === 'N' && b.isActive === 'Y') return 1;
  
          // If both are same in terms of isActive, sort by beNumber
          const aAlphaNum: string[] = a.beNumber.split(/(\d+)/);
          const bAlphaNum: string[] = b.beNumber.split(/(\d+)/);
  
          for (let i = 0; i < Math.max(aAlphaNum.length, bAlphaNum.length); i++) {
            if (aAlphaNum[i] !== bAlphaNum[i]) {
              if (isNaN(parseInt(aAlphaNum[i])) || isNaN(parseInt(bAlphaNum[i]))) {
                // Compare non-digit parts alphabetically
                return aAlphaNum[i].localeCompare(bAlphaNum[i]);
              } else {
                // Compare digit parts numerically
                return parseInt(aAlphaNum[i]) - parseInt(bAlphaNum[i]);
              }
            }
          }
          return 0;
        });
  
        console.log("stat", x);
        this.subSubCategoryFlag = true;
        this.oldSubSubCategoryData = true;
  
        if (x.length == 0) {
          this.amdService
            .fetchAllAssetSecondarySubCategoryDatas(this.beNumberData)
            .subscribe((y: any) => {
              this.accesoriesData = y;
  
              // Apply the same sorting logic to the fallback data
              this.accesoriesData.sort((a: any, b: any) => {
                if (a.isActive === 'Y' && b.isActive === 'N') return -1;
                if (a.isActive === 'N' && b.isActive === 'Y') return 1;
  
                const aAlphaNum: string[] = a.beNumber.split(/(\d+)/);
                const bAlphaNum: string[] = b.beNumber.split(/(\d+)/);
  
                for (let i = 0; i < Math.max(aAlphaNum.length, bAlphaNum.length); i++) {
                  if (aAlphaNum[i] !== bAlphaNum[i]) {
                    if (isNaN(parseInt(aAlphaNum[i])) || isNaN(parseInt(bAlphaNum[i]))) {
                      return aAlphaNum[i].localeCompare(bAlphaNum[i]);
                    } else {
                      return parseInt(aAlphaNum[i]) - parseInt(bAlphaNum[i]);
                    }
                  }
                }
                return 0;
              });
  
              this.subSubCategoryFlag = false;
              this.oldSubSubCategoryData = false;
            });
        }
      });
  }
  
  // accessoriesFun(){
  //   this.amdService
  //   .fetchBENumberAccesories(this.beNumberData.beNumber)
  //   .subscribe((x: any) => {
  //     this.accesoriesData = x;
  //     this.accesoriesData.sort((a: any, b: any) => {
  //       console.log("lastTable", this.tableDatas);
  //       const aAlphaNum: string[] = a.beNumber.split(/(\d+)/);
  //       const bAlphaNum: string[] = b.beNumber.split(/(\d+)/);

  //       for (
  //         let i = 0;
  //         i < Math.max(aAlphaNum.length, bAlphaNum.length);
  //         i++
  //       ) {
  //         if (aAlphaNum[i] !== bAlphaNum[i]) {
  //           if (
  //             isNaN(parseInt(aAlphaNum[i])) ||
  //             isNaN(parseInt(bAlphaNum[i]))
  //           ) {
  //             // Compare non-digit parts alphabetically
  //             return aAlphaNum[i].localeCompare(bAlphaNum[i]);
  //           } else {
  //             // Compare digit parts numerically
  //             return parseInt(aAlphaNum[i]) - parseInt(bAlphaNum[i]);
  //           }
  //         }
  //       }

  //       return 0;
  //     });
  //     console.log("stat", x);
  //     this.subSubCategoryFlag = true;
  //     this.oldSubSubCategoryData = true;
  //     if (x.length == 0) {
  //       // this.amdService.fetchAllSubCategoryDatas(this.beNumberData).subscribe((z : any) => {
  //       //   // console.log("fetched table datas sub category", x);
  //       //   this.accesoriesData = [];
  //       //   this.accesoriesData = z;
  //       //   this.subSubCategoryFlag = false;
  //       // })
  //       this.amdService
  //         .fetchAllAssetSecondarySubCategoryDatas(this.beNumberData)
  //         .subscribe((y: any) => {
  //           this.accesoriesData = [];
  //           this.accesoriesData = y;
  //           console.log("y",y)
  //           console.log("y",this.accesoriesData)
  //           this.accesoriesData.sort((a: any, b: any) => {
  //             console.log("lastTable", this.tableDatas);
  //             const aAlphaNum: string[] = a.beNumber.split(/(\d+)/);
  //             const bAlphaNum: string[] = b.beNumber.split(/(\d+)/);

  //             for (
  //               let i = 0;
  //               i < Math.max(aAlphaNum.length, bAlphaNum.length);
  //               i++
  //             ) {
  //               if (aAlphaNum[i] !== bAlphaNum[i]) {
  //                 if (
  //                   isNaN(parseInt(aAlphaNum[i])) ||
  //                   isNaN(parseInt(bAlphaNum[i]))
  //                 ) {
  //                   // Compare non-digit parts alphabetically
  //                   return aAlphaNum[i].localeCompare(bAlphaNum[i]);
  //                 } else {
  //                   // Compare digit parts numerically
  //                   return parseInt(aAlphaNum[i]) - parseInt(bAlphaNum[i]);
  //                 }
  //               }
  //             }

  //             return 0;
  //           });
  //           this.subSubCategoryFlag = false;
  //           this.oldSubSubCategoryData = false;
  //           // y.forEach(element => {
  //           //   console.log(element)
  //           //   element.beNumber = element.beNumber;
  //           //   element.assetDescription.assetCategory.beCategoryName = element.assetCategoryName;
  //           //   element.assetDescription.assetConditionalStatus.assetStatusCode = element.beConditionalStatus
  //           //   element.assetManufacturerDetail.manufacturer.manufacturerName = element.manufacturerNameFromBeCodeManufacturer
  //           //   element.assetManufacturerDetail.modelName = element.modelNumberName
  //           //   element.assetFinancial.assetFinancialDetail.serialNumber = element.serialNumber
  //           //   element.assetFinancial.assetFinancialDetail.purchaseCost = element.purchaseCost
  //           //   this.accesoriesData.push(element);
  //           // });
  //           // this.accesoriesData = y;
  //         });
  //     }
  //   });
  // }
  
  addAccSubmit() {
   console.log("be no",this.beNumberData)
   console.log("array",this.accesoriesData)
   console.log("id",this.accesoriesData?.id)
   console.log("assetid",this.accesoriesData?.assetId)

    const selectedRows = this.addAcessListArray.filter(datas => datas.selected);

    console.log(selectedRows);
    
  
    if (selectedRows.length === 0) {
      console.error('No rows selected');  
      Swal.fire("","Kindly Select Any Accesories",'error');
      return;
    }
  
    const data = []

       selectedRows.map(item => {
        
        const selectedModel = this.beCodeManufacturer.find(model => model.id === item.beCodeAndManufacturerId);
        const manuid =this.manufactureArray.find(manu=>manu.manufacturerName === item.manufacturerId)

  
        let obj={      
          assetBeNumber: this.beNumberData.beNumber,
          assetId: this.beNumberData.id, 
          accessoriesBeNumber: item.beNumber,
          assetAccessoriesId: item.id, 
          // beCodeAndManufacturerId: item.beCodeAndManufacturerId, 
          manufacturerId:manuid?.id,

          manufacturerName: item.manufacturerId,
          // modelNumberName: selectedModel ? selectedModel.modelNumber : '',
          modelNumberName: selectedModel ? selectedModel.modelNumber : item.modelNumber,
          serialNumber: item.serialNumber,
          createUserId: this.currentUser.name,
        };

      data.push(obj)

      })

      console.log(data,"hkhhkhkh");
      
    
    
  
    this.amdServiceNew.fetchAccessoriesAdd(data).subscribe(
      (x: any) => {
        console.log('Success:', x);
        this.accessoriesFun()
        Swal.fire("","Accessories Add Successfully","success")
        this.add.hide();

      },
      (error:any) => {

        if(error.status == 400){
          Swal.fire("",error.error,"error")
        }
        else if(error.status == 200){
          this.accessoriesFun()
          Swal.fire("","Accessories Add Successfully","success")
          this.add.hide();
  

        }
      }
    );
  }
  
  filteredManufacturer: any = [];
  onItemSelectCategory() {
    this.amdServiceNew.fetchAllbeCodeAndManufacturer().subscribe((x: any) => {
      this.beCodeAndMAnufacturer = [];
      this.beCodeAndMAnufacturer = x;
      this.beCodeAndMAnufacturer = this.beCodeAndMAnufacturer.filter(
        (obj) => obj.is_active == "Y" && obj.status == "Verified"
      );

      this.filteredManufacturer = [];
      this.filteredManufacturer = this.beCodeAndMAnufacturer.filter(
        (manufacturer) =>
          manufacturer.assetCategoryId ==
          this.beNumberData?.assetDescription?.assetCategory?.beCategoryId
      );

      this.filteredManufacturer = [
        ...new Set(
          this.filteredManufacturer.map((item) => item.manufacturerName)
        ),
      ];

      console.log(this.filteredManufacturer);
    });
  }
  beCodeManufacturer: any = [];
  onItemSelectManufacturer(event,datas) {
    this.beCodeManufacturer = [];

    console.log(event);

    datas.beCodeManufacturer = this.beCodeAndMAnufacturer.filter(
      (obj) =>
        obj.manufacturerName == event &&
        obj.assetCategoryId ==
          this.beNumberData?.assetDescription?.assetCategory?.beCategoryId
    );
  }

  onItemSelectModel(event,datas){
    // const selectedModel = this.beCodeManufacturer.find(model => model.id === event);
    const selectedModel = datas.beCodeManufacturer.find(model => model.id === event);
    console.log("1",selectedModel)
    console.log("2",datas.beCodeManufacturer)
    datas.modelNumber = selectedModel?.modelNumber


  }
  cancelActivate(){

  }
  cancelDeactive(){

  }
  downloadPdfnew() {
    console.log(this.accesoriesData, "gh");

    let sparesHistory = this.sparesHistoryData.concat(
      this.sparesHistoryDataOld
    );
    // let serviceHistory = this.serviceHistoryData.concat(
    //   this.serviceHistoryDataOld
    // );
    let serviceHistory = this.serviceCurrentFlag?this.serviceHistoryData: this.serviceHistoryDataOld

    console.log("Thasu",this.serviceHistoryData)
    console.log("Asu",this.serviceHistoryDataOld)

    let header = [];
    let widths = [];
    let header1 = [];
    let header5 = [];
    let header6 = [];

    let widths1 = [];
    let header2 = [];
    let widths2 = [];
    let header3 = [];
    let widths3 = [];
    let widths5 = [];
    let widths6 = [];

    const tableBody = [
      [
        { text: "Date Start/Stop", alignment: "center", bold: true },
        {
          text: "BE Conditional Status",
          alignment: "center",
          bold: true,
        },
      ],
    ];

    let d1 = [
      {
        text:
          this.beNumberData.createdDate == null
            ? "-"
            : dateFormat(this.beNumberData.createdDate, "dd/mm/yyyy HH:MM:ss"),
        alignment: "center",
        bold: true,
      },

      {
        text:
          this.conditionalStatus?.assetConditionalStatusOldCode == null
            ? "-"
            : this.conditionalStatus?.assetConditionalStatusOldCode,
        alignment: "center",
        bold: true,
      },
    ];

    let d2 = [
      {
        text: (() => {
          const formatDate = (date) =>
            date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : "-";

          if (this.conditionalStatus != null) {
            return this.conditionalStatus.zm_validated_date !== null
              ? formatDate(this.conditionalStatus.zm_validated_date)
              : "-";
          } else {
            return this.beNumberData.createdDate !== null
              ? formatDate(this.beNumberData.createdDate)
              : "-";
          }
        })(),

        alignment: "center",
        bold: true,
      },

      {
        text:
          this.beNumberData?.assetDescription?.assetConditionalStatus
            ?.assetStatusCode == null
            ? "-"
            : this.beNumberData?.assetDescription?.assetConditionalStatus
                ?.assetStatusCode,
        alignment: "center",
        bold: true,
      },
    ];

    if (this.conditionalStatus != null) {
      tableBody.push(d1);
    }

    tableBody.push(d2);

    let datas = [];
    let datas1 = [];
    let datas2 = [];
    let datas3 = [];
    let datas5 = [];
    let datas6 = [];

    let index = 1;
    let logo = this.mEntity.logo3;

    let test = [
      { a: "header", b: "text" },
      { a: "header1", b: "text2" },
      { a: "header2", b: "text2" },
    ];
    const now = new Date();
    masks.hammerTime = "dd/mm/yyyy HH:MM";
    let name = this.currentUser.name;
    var docDefinition = {
      footer: function (currentPage, pageCount) {
        let footer = {
          columns: [
            {
              text: "Date : " + dateFormat(now, "hammerTime"),
              bold: true,
              margin: [40, 0, 0, 0],
            },

            {
              text: "Username :" + "" + name,
              bold: true,
              margin: [40, 0, 0, 0],
            },
            {
              text: "Page " + currentPage.toString() + " of " + pageCount,
              alignment: "right",
              margin: [0, 0, 40, 0],
            },
          ],
        };
        return footer;
      },
      content: [
        {
          image: logo,
          fit: [150, 70],
          alignment: "center",
          margin: [0, -30, 0, 10],
        },
        {
          text: "Asset Information    ",
          fontSize: 20,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },

        {
          text:
            "Asset Information" +
            "-" +
            this.beNumberData?.beNumber +
            "/" +
            this.beNumberData?.assetDescription?.assetCategory?.beCategoryName +
            "/" +
            this.beNumberData?.assetDescription?.assetConditionalStatus
              ?.assetStatusCode,
          fontSize: 16,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            {
              text: [
                "Location Info   : ",
                {
                  text:
                    this.beNumberData?.assetLocation.district.districtName +
                    "/" +
                    this.beNumberData?.assetLocation.district.circleName +
                    "/" +
                    this.beNumberData?.assetLocation.district.stateName,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "BE Type                               : ",
                {
                  text: this.beNumberData?.assetDescription.ownership
                    .ownershipName,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Expected Service Life           : ",
                {
                  text: this.beNumberData.assetStatutory.assetStatutoryDetail
                    .expectedServiceLife,
                  bold: true,
                  alignment: "left",
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Clinic Info         : ",
                {
                  text:
                    this.beNumberData.assetLocation.clinic.clinicCode +
                    "/" +
                    this.beNumberData.assetLocation.clinic.clinicCategoryName,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Cost Center                        : ",
                {
                  text: this.beNumberData.assetLocation.clinic.costCenter,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Depreciation Till Date           : ",
                { text: "NA", bold: true, alignment: "left" },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "BE General Name : ",
                {
                  text: this.beNumberData.assetDescription.assetCategory
                    .beGeneralName,
                  bold: true,
                  alignment: "center",
                },
              ],
            },
            // fontSize: 10,
            // bold: true,
            // },

            {
              text: [
                "BE Code                              : ",
                {
                  text: this.beNumberData?.assetDescription?.assetCategory
                    ?.beCode,
                  bold: true,
                  alignment: "left",
                },
                "RM",
              ],
            },

            {
              text: [
                "Installment No                       :",
                { text: " NA", bold: true, alignment: "left" },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Work Group      : ",
                {
                  text: this.beNumberData?.assetDescription?.workGroup
                    ?.workGroupName,
                  bold: true,
                  alignment: "center",
                },
              ],
            },

            {
              text: [
                "BE Group                             : ",
                {
                  text: this.beNumberData?.assetDescription?.workGroup
                    ?.workGroupName,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "SM Frequency/Year              : ",
                {
                  text: this.beNumberData?.assetDescription?.assetCategory
                    ?.maintenanceFrequency,
                  bold: true,
                  alignment: "left",
                },
                "Year",
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Clinic Name     : ",
                {
                  text: this.beNumberData?.assetLocation?.clinic?.clinicName,
                  bold: true,
                  alignment: "center",
                },
              ],
            },

            {
              text: [
                "BE Maintenance Type       : ",
                {
                  text: this.beNumberData?.assetStatutory?.maintenanceType
                    ?.maintenanceType,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Clinic Type                              : ",
                {
                  text: this.beNumberData?.assetLocation?.clinic
                    ?.clinicTypeCode,
                  bold: true,
                  alignment: "left",
                },
              ],
            },
          ],
        },

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: [header, ...datas],
          },
          alignment: "center",
        },
        {
          table: {
            headerRows: 1,
            widths: widths,
            body: [header, ...datas],
          },
          alignment: "center",
        },

        {
          columns: [
            {
              text: "Summary",

              fontSize: 17,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Equipment Info ",
              fontSize: 15,
              bold: true,
            },
            {
              text: "Rental Info ",
              fontSize: 15,
              bold: true,
              alignment: "left",
            },
            {
              text: "Maintenance Info",
              fontSize: 15,
              bold: true,
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "JKKP Certificate Number : ",
                {
                  text:
                    this.beNumberData?.assetStatutory?.assetStatutoryDetail
                      ?.jkkpCertificateNumber == null ||
                    this.beNumberData?.assetStatutory?.assetStatutoryDetail
                      ?.jkkpCertificateNumber == ""
                      ? "NA"
                      : this.beNumberData?.assetStatutory?.assetStatutoryDetail
                          ?.jkkpCertificateNumber,
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Rental Start Date     : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetRental == null ||
                    this.beNumberData?.assetFinancial?.assetRental == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial?.assetRental
                            ?.rentalStartDate,
                          "dd/mm/yyyy"
                        ),
                },
              ],
            },

            {
              text: [
                "Warranty Start Date       : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetMaintenance
                      ?.warrentyStartDate == null ||
                    this.beNumberData?.assetFinancial?.assetMaintenance
                      ?.warrentyStartDate == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial?.assetMaintenance
                            ?.warrentyStartDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Audit Start Date                 : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.auditStartDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.auditStartDate == ""
                      ? "NA"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.auditStartDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Rental End Date       : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetRental == null ||
                    this.beNumberData?.assetFinancial?.assetRental == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial?.assetRental
                            ?.rentalEndDate,
                          "dd/mm/yyyy"
                        ),
                },
              ],
            },

            {
              text: [
                "Warranty Expiry Date     : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetMaintenance
                      ?.warrentyExpiryDate == null ||
                    this.beNumberData?.assetFinancial?.assetMaintenance
                      ?.warrentyExpiryDate == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial?.assetMaintenance
                            ?.warrentyExpiryDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Acceptance Date               : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.acceptanceDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.acceptanceDate == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.acceptanceDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: "Equipment  Details",
              fontSize: 15,
              bold: true,
              alignment: "left",
            },

            {
              text: [
                "Purches Date                  : ",
                {
                  text: dateFormat(
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.purchaseDate,
                    "dd/mm/yyyy"
                  ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Installation Date                : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.installiationDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.installiationDate == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.installiationDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },
            {
              text: [
                "KEWPA Number       : ",
                {
                  text:
                    this.beNumberData?.assetStatutory?.assetStatutoryDetail
                      ?.kewpaNumber == null ||
                    this.beNumberData?.assetStatutory?.assetStatutoryDetail
                      ?.kewpaNumber == ""
                      ? "NA"
                      : this.beNumberData?.assetStatutory?.assetStatutoryDetail
                          ?.kewpaNumber,
                  bold: true,
                  alignment: "center",
                },
              ],
            },

            {
              text: "Provider Info",
              fontSize: 15,
              bold: true,
              alignment: "left",
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "CPC Date                           : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.cpcDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.cpcDate == ""
                      ? "NA"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.cpcDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Serial  No                  : ",
                {
                  text: this.beNumberData?.assetFinancial?.assetFinancialDetail
                    ?.serialNumber,
                  bold: true,
                  alignment: "center",
                },
              ],
            },
            {
              text: [
                "Supplier  Name               : ",
                {
                  text:
                    this.beNumberData?.assetSupplier?.supplier == null ||
                    this.beNumberData?.assetSupplier?.supplier == ""
                      ? "NA"
                      : this.beNumberData?.assetSupplier?.supplier
                          ?.supplierName,
                  bold: true,
                  alignment: "center",
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              text: [
                "Statuatory  Expiry Date    : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.statutoryExpiryDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.statutoryExpiryDate == ""
                      ? "NA"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.statutoryExpiryDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Batch  No                  : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.batchNumber == null ||
                    this.beNumberData?.assetFinancial?.batchNumber == ""
                      ? "Not Applicable"
                      : this.beNumberData?.assetFinancial?.batchNumber
                          ?.batchNumberName,
                  bold: true,
                  alignment: "left",
                },
              ],
            },
            {
              text: [
                "Manufacturer Name      : ",
                {
                  text: this.beNumberData?.assetManufacturerDetail?.manufacturer
                    ?.manufacturerName,
                  bold: true,
                  alignment: "center",
                },
              ],
            },
          ],
        },
        {
          columns: [
            //{
            {
              text: [
                "Batch End Date                 : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.batchEndDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.batchEndDate == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.batchEndDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "left",
                },
              ],
            },

            {
              text: [
                "Variation Order         : ",
                {
                  text:
                    this.beNumberData?.assetDescription?.variationOrder ==
                      null ||
                    this.beNumberData?.assetDescription?.variationOrder == ""
                      ? "NA"
                      : this.beNumberData?.assetDescription?.variationOrder
                          ?.variationOrderName,
                  bold: true,
                  alignment: "center",
                },
              ],
            },
            {
              text: [
                "Model                               : ",
                {
                  text: this.beNumberData?.assetManufacturerDetail?.modelName,
                  bold: true,
                  alignment: "left",
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              // text:''
              text: [
                "T&C Date:                           : ",
                {
                  text:
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.tcDate == null ||
                    this.beNumberData?.assetFinancial?.assetFinancialDetail
                      ?.tcDate == ""
                      ? "Not Applicable"
                      : dateFormat(
                          this.beNumberData?.assetFinancial
                            ?.assetFinancialDetail?.tcDate,
                          "dd/mm/yyyy"
                        ),
                  bold: true,
                  alignment: "center",
                },
              ],
            },

            {
              text: "",
            },
            {
              text: "",
            },
          ],
        },

        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },
        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: [header, ...datas],
          },
          alignment: "center",
        },
        {
          table: {
            headerRows: 1,
            widths: widths,
            body: [header, ...datas],
          },
          alignment: "center",
        },
        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Conditional  History ",

              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          table: {
            headerRows: 1,
            widths: [383, 385],
            body: tableBody,
          },
        },

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: [header, ...datas],
          },
          alignment: "center",
        },

        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Location  History ",

              fontSize: 13,
              bold: true,
            },
          ],
        },
        {
          table: {
            headerRows: 1,
            widths: [240, 240, 280],
            body: [
              [
                { text: "Date Start/Stop", alignment: "center", bold: true },
                { text: "Clinic Code ", alignment: "center", bold: true },
                { text: "Clinic Name ", alignment: "center", bold: true },
              ],
              [
                {
                  text: (() => {
                    const formatDate = (date) =>
                      date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : "-";

                    if (this.conditionalStatus != null) {
                      return this.beNumberData.createdDate !== null
                        ? formatDate(this.beNumberData.createdDate)
                        : this.locationStatus?.validated_date_zm !== null
                        ? formatDate(this.locationStatus?.validated_date_zm)
                        : "-";
                    } else {
                      return this.beNumberData.createdDate !== null
                        ? formatDate(this.beNumberData.createdDate)
                        : "-";
                    }
                  })(),
                  alignment: "center",
                  bold: true,
                },
                {
                  text: this.beNumberData.assetLocation.clinic.clinicCode,
                  alignment: "center",
                  bold: true,
                },
                {
                  text: this.beNumberData.assetLocation.clinic.clinicName,
                  alignment: "center",
                  bold: true,
                },
              ],
            ],
          },
        },

        {
          table: {
            headerRows: 1,
            widths: widths2,
            body: [header2, ...datas2],
          },
          alignment: "center",
        },

        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Service  History ",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        serviceHistory.length == 0
          ? "No existing history of Service for this BE number"
          : "",

        serviceHistory.forEach((data) => {
          header1 = [
            {
              text: "     WR Number",
              alignment: "center",
              bold: true,
            },
            {
              text: "   WR Date & Time ",
              alignment: "center",
              bold: true,
            },

            {
              text: "     WO Number ",
              alignment: "center",
              bold: true,
            },
            {
              text: "     WO Date & Time",
              alignment: "center",
              bold: true,
            },

            {
              text: "     Problem Reported",
              alignment: "center",
              bold: true,
            },
            {
              text: "    Action Taken",
              alignment: "center",
              bold: true,
            },
            {
              text: "    WO Completed Date & Time ",
              alignment: "center",
              bold: true,
            },
            {
              text: "   Engineer Name ",
              alignment: "center",
              bold: true,
            },
            {
              text: "   Material Cost ",
              alignment: "center",
              bold: true,
            },
          ];
          console.log(
            "dataaaaaaa",
            data,
            "serviceHistoryData",
            this.serviceHistoryData,
            data.wrNumber
          );

          datas1.push([
            {
              text: data?.wrNumber || "-",
              alignment: "center",
            },
            {
              text:
                data?.wrDateTime == null || data?.wrDateTime == ""
                  ? "-"
                  : dateFormat(data.wrDateTime, "dd/mm/yyyy hh:MM:ss "),

              alignment: "center",
            },

            {
              text: data?.woNumber || "-",
              alignment: "center",
            },
            {
              text:
                data?.woDateTime == null || data?.woDateTime == ""
                  ? "-"
                  : dateFormat(data?.woDateTime, "dd/mm/yyyy hh:MM:ss "),

              alignment: "center",
            },

            {
              text: data?.problemReported || "-",
              alignment: "center",
            },
            {
              text: data?.actionTaken || "-",
              alignment: "center",
            },
            {
              text: data?.completionDateTime,

              alignment: "center",
            },

            {
              text: data?.assignTo || "-",
              alignment: "center",
            },
            {
              text: data?.materialCost || "-",
              alignment: "center",
            },
          ]);
        }),
        {
          table: {
            headerRows: 1,
            widths: [60, 80, 60, 90, 120, 100, 80, 60, 60],
            body: [header1, ...datas1],
          },
          alignment: "center",
        },
        //
        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Spares  History ",
              fontSize: 13,
              bold: true,
            },
          ],
        },
        sparesHistory.length == 0
          ? "No existing history of spares for this BE number"
          : "",

        sparesHistory.forEach((data) => {
          header3 = [
            {
              text: "     MR Number ",
              alignment: "center",
              bold: true,
            },
            {
              text: "    MR Date & Time",
              alignment: "center",
              bold: true,
            },
            {
              text: "     WO Number",
              alignment: "center",
              bold: true,
            },
            {
              text: "      	WO Date & Time",
              alignment: "center",
              bold: true,
            },
          ];

          widths3 = ["*", "*", "*", "*"];

          datas3.push([
            {
              text: data?.mrNumber,
              alignment: "center",
            },
            {
              text:
                data?.mrDateTime == null || data?.mrDateTime == ""
                  ? "-"
                  : dateFormat(data?.mrDateTime, "dd/mm/yyyy hh:MM:ss "),

              alignment: "center",
            },
            {
              text: data?.woNumber,
              alignment: "center",
            },
            {
              text:
                data?.woDateTime == null || data?.woDateTime == ""
                  ? "-"
                  : dateFormat(data?.woDateTime, "dd/mm/yyyy hh:MM:ss "),
            },
          ]);
        }),
        {
          table: {
            headerRows: 1,
            widths: widths3,
            body: [header3, ...datas3],
          },
          alignment: "center",
        },
        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },
        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Accesories",

              fontSize: 13,
              bold: true,
            },
          ],
        },
        this.accesoriesData.length == 0
          ? " Accessories is not Applicable for this BE number Number and Be Category "
          : "",

        this.accesoriesData.forEach((data) => {
          header5 = [
            {
              text: "     BE Number",
              alignment: "center",
              // bold: true
            },
            {
              text: "    BE Category ",
              alignment: "center",
              //  bold: true
            },
            {
              text: "   BE Conditional Status",
              alignment: "center",
              //  bold: true
            },
            {
              text: "   Manufacturer",
              alignment: "center",
              //  bold: true
            },
            {
              text: "    Model",
              alignment: "center",
              //  bold: true
            },
            {
              text: "   Serial Number",
              alignment: "center",
              // bold: true
            },
            {
              text: "      Purchase Cost",
              alignment: "center",
              //  bold: true
            },
            {
              text: "      Jkkp Certf No",
              alignment: "center",
              //  bold: true
            },
            {
              text: "      Statutory Expiry Date",
              alignment: "center",
              //  bold: true
            },
          ];
          widths5 = [80, 80, 75, 74, 80, 78, 80, 80, 80];

          datas5.push([
            {
              text: data?.beNumber,
              alignment: "center",
              bold: true,
            },

            {
              text: data?.assetDescription?.assetCategory.beCategoryName,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.assetDescription?.assetConditionalStatus
                ?.assetStatusCode,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.assetManufacturerDetail?.manufacturer
                ?.manufacturerName,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.assetManufacturerDetail?.modelName,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.assetFinancial?.assetFinancialDetail?.serialNumber,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.assetFinancial?.assetFinancialDetail?.purchaseCost,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.assetStatutory?.assetStatutoryDetail
                ?.jkkpCertificateNumber,
              alignment: "center",
              bold: true,
            },
            {
              text:
                data?.assetStatutory?.assetStatutoryDetail
                  ?.statutoryExpiryDate == null
                  ? "NA"
                  : data?.assetStatutory?.assetStatutoryDetail
                      ?.statutoryExpiryDate,
              alignment: "center",
              bold: true,
            },
          ]);
        }),

        {
          table: {
            headerRows: 1,
            widths: widths5,
            body: [header5, ...datas5],
          },
          alignment: "center",
        },
        {
          columns: [
            {
              text: " ",
              fontSize: 13,
              bold: true,
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
              alignment: "left",
            },
            {
              text: "",
              fontSize: 13,
              bold: true,
            },
          ],
        },

        {
          columns: [
            {
              text: "Standard Components",
              fontSize: 13,
              bold: true,
            },
          ],
        },
        this.accesoriesDataStandardComponents.length == 0
          ? "No Existing history of Standard Components  for this BE number "
          : this.accesoriesDataStandardComponents,

        this.accesoriesDataStandardComponents.forEach((data) => {
          header6 = [
            {
              text: "     Accessory/Component Description ",
              alignment: "center",
              //  bold: true
            },
            {
              text: "    Manufacturer",
              alignment: "center",
              //  bold: true
            },
            {
              text: "     Model",
              alignment: "center",
              //  bold: true
            },
            {
              text: "      	Serial Number",
              alignment: "center",
              //  bold: true
            },
            {
              text: "      	Part Number",
              alignment: "center",
              //  bold: true
            },
          ];
          widths6 = ["*", "*", "*", "*", "*"];

          datas6.push([
            {
              text: data?.accessoryComponentDescription,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.manufacturerNameFromBeCodeManufacturer,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.modelNumberName,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.serialNumber,
              alignment: "center",
              bold: true,
            },
            {
              text: data?.partNumber,
              alignment: "center",
              bold: true,
            },
          ]);
        }),
        {
          table: {
            headerRows: 1,
            widths: widths6,
            body: [header6, ...datas6],
          },
          alignment: "center",
        },
      ],

      pageSize: "A4",
      pageOrientation: "landscape",
      defaultStyle: {
        font: pdfMake.vfs.Roboto,
        fontSize: 10,
        lineHeight: 1.3,
      },
      preserveSpace: {
        preserveLeadingSpaces: true,
      },
    };

    pdfMake.createPdf(docDefinition).download("BE Number Info.pdf");
  }
  generateExcelservice() {
    console.log("excel,,,,,");
    const title = ["", "", "", " Service  History ", "", ""];
    let header = [];
    header = [
      "                   WR Number",
      "                   WR Date & Time",
      "                                    WO Number",
      "                                 WO Date & Time   ",
      "                   Problem Reported",
      "Action Taken  ",
      "            WO Completed Date & Time",
      "              Engineer Name",
      "            Material Cost",
    ];
    let datas = [];
    let index = 1;
    // if(this.serviceCurrentFlag){
    //   this.serviceHistoryData.forEach(data => {
    //     datas.push(
    //         [(data.wrNumber), (dateFormat(data.wrDateTime, "dd/mm/yyyy")), (data.woNumber), (dateFormat(data.woDateTime, "dd/mm/yyyy")),(data.problemReported),
    //         (data.actionTaken),(dateFormat(data.completionDateTime, "dd/mm/yyyy")) , (data.assignTo), (data.materialCost),
    //         (data.wrNumber), (dateFormat(data.wrDateTime, "dd/mm/yyyy")), (data.woNumber), (dateFormat(data.woDateTime, "dd/mm/yyyy")),
    //         (data.problemReported), (data.actionTaken), (data.completionDateTime), (data.assignTo),(data.materialCost)]

    //     )
    //     index++
    // })

    // }
    // else{
    //   this.serviceHistoryDataOld.forEach(data => {
    //     datas.push(
    //         [(data.wrNumber), (dateFormat(data.wrDateTime, "dd/mm/yyyy")), (data.woNumber), (dateFormat(data.woDateTime, "dd/mm/yyyy")),(data.problemReported),
    //         (data.actionTaken),(dateFormat(data.completionDateTime, "dd/mm/yyyy")) , (data.assignTo), (data.materialCost),
    //         (data.wrNumber), (dateFormat(data.wrDateTime, "dd/mm/yyyy")), (data.woNumber), (dateFormat(data.woDateTime, "dd/mm/yyyy")),
    //         (data.problemReported), (data.actionTaken), (data.completionDateTime), (data.assignTo),(data.materialCost)]

    //     )
    //     index++
    // })

    // }
    console.log("new", this.serviceHistoryData);
    console.log("old", this.serviceHistoryData);

    if (this.serviceCurrentFlag) {
      this.serviceHistoryData.forEach((data) => {
        console.log("this.servicecurrent", this.serviceCurrentFlag);
        datas.push([
          data.wrNumber == null ? "-" : data.wrNumber,
          data.wrDateTime == null
            ? "-"
            : dateFormat(data.wrDateTime, "dd/mm/yyyy HH:MM:ss"),

          data.woNumber == null ? "-" : data.woNumber,
          data.woDateTime == null
            ? "-"
            : dateFormat(data.woDateTime, "dd/mm/yyyy HH:MM:ss"),

          data.problemReported,
          data.actionTaken,
          data.completionDateTime == null
            ? "-"
            : dateFormat(data.completionDateTime, "dd/mm/yyyy HH:MM:ss"),
          data.assignTo,
          data.materialCost,
        ]);
        index++;
      });
    } else {
      this.serviceHistoryDataOld.forEach((data) => {
        datas.push([
          data.wrNumber == null ? "-" : data.wrNumber,
          data.wrDateTime == null
            ? "-"
            : dateFormat(data.wrDateTime, "dd/mm/yyyy HH:MM:ss"),
          data.woNumber == null ? "-" : data.woNumber,
          data.woDateTime == null
            ? "-"
            : dateFormat(data.woDateTime, "dd/mm/yyyy HH:MM:ss"),
          data.problemReported,
          data.actionTaken,
          data.completionDateTime == null
            ? "-"
            : dateFormat(data.completionDateTime, "dd/mm/yyyy HH:MM:ss"),
          data.assignTo,
          data.materialCost,
        ]);
        index++;
      });
    }

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("service History");
    let titleRow = worksheet.addRow(title);
    worksheet.addRow([
      "State : " + this.beNumberData?.assetLocation.district.stateName,
      "",
      "",
      "",
      "Clinic Name : " + this.beNumberData?.assetLocation?.clinic?.clinicName,
    ]).font = {
      bold: true,
    };
    worksheet.addRow([
      "Circle : " + this.beNumberData?.assetLocation.district.circleName,
      "",
      "",
      "",
      "Be Number: " + this.beNumberData?.beNumber,
    ]).font = {
      bold: true,
    };
    worksheet.addRow([
      "District : " + this.beNumberData?.assetLocation.district.districtName,
      "",
      "",
      "",
      "Be Category: " +
        this.beNumberData?.assetDescription?.assetCategory?.beCategoryName,
    ]).font = {
      bold: true,
    };

    titleRow.font = {
      size: 14,
      bold: true,
    };
    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);
    headerRow.font = {
      size: 11,
      bold: true,
    };
    // worksheet.addRow([]);

    // worksheet.mergeCells('A1:A1');
    // worksheet.mergeCells('B1:B1');
    // worksheet.mergeCells('C1:C1');
    // worksheet.mergeCells("D3:D3");
    // worksheet.getCell('D3').alignment = {
    //   vertical: 'middle',
    //   horizontal: 'center',
    // }
    // worksheet.addRow([]);
    headerRow.eachCell((cell, number) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
    datas.forEach((d) => {
      let row = worksheet.addRow(d);
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });
    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 40;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 30;
    worksheet.getColumn(5).width = 50;
    worksheet.getColumn(6).width = 40;
    worksheet.getColumn(7).width = 30;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 20;
    worksheet.getColumn(10).width = 40;
    worksheet.getColumn(11).width = 40;
    worksheet.getColumn(12).width = 40;
    worksheet.getColumn(13).width = 40;
    worksheet.getColumn(14).width = 40;
    worksheet.getColumn(15).width = 40;
    worksheet.getColumn(16).width = 40;
    worksheet.getColumn(17).width = 40;
    worksheet.getColumn(18).width = 40;
    worksheet.getColumn(19).width = 40;

    worksheet.getColumn(1).alignment = { wrapText: true, horizontal: "left" };
    worksheet.getColumn(2).alignment = { wrapText: true, horizontal: "left" };
    worksheet.getColumn(3).alignment = { wrapText: true, horizontal: "left" };
    worksheet.getColumn(4).alignment = { wrapText: true, horizontal: "right" };
    worksheet.getColumn(5).alignment = { wrapText: true, horizontal: "left" };
    worksheet.getColumn(6).alignment = { wrapText: true, horizontal: "left" };
    worksheet.getColumn(7).alignment = { wrapText: true, horizontal: "right" };
    worksheet.getColumn(8).alignment = { wrapText: true, horizontal: "left" };
    worksheet.getColumn(9).alignment = { wrapText: true, horizontal: "right" };

    worksheet.addRow([]);
    const userName = this.userName;
    const now = new Date();
    masks.hammerTime = "dd/mm/yyyy HH:MM";
    let footerRow = worksheet.addRow([
      "Date : " + dateFormat(now, "hammerTime"),
    ]);
    let sidecoloum = worksheet.addRow([`User Name: ${userName}`]);
    worksheet.addRow([]);
    worksheet.mergeCells(`A${footerRow.number}:C${footerRow.number}`);
    worksheet.mergeCells(`A${sidecoloum.number}:C${sidecoloum.number}`);

    // if (this.dataList.length > 0) {
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fs.saveAs(blob, "service History.xlsx");
    });
    // }
  }
  spareHistory: any = [];
  generateExcel() {
    this.amdService
      .spareHistoryExcel(this.beNumberData.beNumber)
      .subscribe((x: any) => {
        this.spareHistory = [];
        this.spareHistory = x;

        console.log(this.spareHistory);
        console.log(this.spareHistory?.mrDetails);

        const title = ["", "", "", "Spares History ", "", ""];
        let header = [
          "                   WO Number",
          "                WO Date & Time              ",
          "                     MR No            ",
          "                MR Date & Time              ",
          "                   Item Code               ",
          "                   Item Description",
          "            Quantity",
          "              Issue to",
          "                Issue Cost    ",
          "            PR Number",
          "                PR Date & Time              ",
          "               PO Number",
          "                PO Date & Time              ",
          "                GRN Date & Time              ",
          "                   Supplier Name              ",
        ];
        let datas = [];
        let index = 1;
        this.spareHistory.forEach((data) => {
          if (data.mrDetails && data.mrDetails.length > 0) {
            data.mrDetails.forEach((mrDetail) => {
              datas.push([
                data.woNumber || "NA",
                data.woDateTime
                  ? dateFormat(data.woDateTime, "dd/mm/yyyy HH:MM:ss")
                  : "NA",
                data.mrNumber || "NA",
                data.mrDateTime
                  ? dateFormat(data.mrDateTime, "dd/mm/yyyy HH:MM:ss")
                  : "NA",
                mrDetail.stockCode || "NA",
                mrDetail.stockDescription || "NA",
                mrDetail.issueQuantity || "NA",
                mrDetail.issueTo || "NA",
                mrDetail.issueCost || "NA",
                mrDetail.prNumber || "NA",
                mrDetail.prDate
                  ? dateFormat(mrDetail.prDate, "dd/mm/yyyy HH:mm:ss")
                  : "NA",
                mrDetail.poNumber || "NA",
                mrDetail.poDateTime
                  ? dateFormat(mrDetail.poDateTime, "dd/mm/yyyy HH:mm:ss")
                  : "NA",
                mrDetail.grndateTime
                  ? dateFormat(mrDetail.grndateTime, "dd/mm/yyyy HH:mm:ss")
                  : "NA",
                mrDetail.supplierName || "NA",
              ]);
            });
          } else {
            datas.push([
              data.woNumber || "NA",
              data.woDateTime
                ? dateFormat(data.woDateTime, "dd/mm/yyyy HH:MM:ss")
                : "NA",
              data.mrNumber || "NA",
              data.mrDateTime
                ? dateFormat(data.mrDateTime, "dd/mm/yyyy HH:MM:ss")
                : "NA",
              "NA",
              "NA",
              "NA",
              "NA",
              "NA",
              "NA",
              "NA",
              "NA",
              "NA",
              "NA",
            ]);
          }
          index++;
        });

        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet("Spares History");
        let titleRow = worksheet.addRow(title);
        worksheet.addRow([
          "State : " + this.beNumberData?.assetLocation.district.stateName,
          "",
          "",
          "",
          "",
          "Clinic Name : " +
            this.beNumberData?.assetLocation?.clinic?.clinicName,
        ]).font = {
          bold: true,
        };
        worksheet.addRow([
          "Circle : " + this.beNumberData?.assetLocation.district.circleName,
          "",
          "",
          "",
          "",
          "Be Number: " + this.beNumberData?.beNumber,
        ]).font = {
          bold: true,
        };
        worksheet.addRow([
          "District : " +
            this.beNumberData?.assetLocation.district.districtName,
          "",
          "",
          "",
          "",
          "Be Category: " +
            this.beNumberData?.assetDescription?.assetCategory?.beCategoryName,
        ]).font = {
          bold: true,
        };
        titleRow.font = {
          size: 14,
          bold: true,
        };

        const columnWidths = [
          30, 33, 18, 30, 30, 45, 20, 30, 20, 20, 20, 20, 20, 20, 40,
        ];
        console.log("header", header);

        header.forEach((headerText, columnIndex) => {
          const cell = worksheet.getCell(5, columnIndex + 1);
          cell.value = headerText;
          cell.alignment = { horizontal: "center" };
          cell.font = {
            size: 11,
            bold: true,
          };
          worksheet.getColumn(columnIndex + 1).width =
            columnWidths[columnIndex];
        });

        datas.forEach((d) => {
          let row = worksheet.addRow(d);
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        worksheet.getColumn(7).alignment = {
          wrapText: true,
          horizontal: "center",
        };
        worksheet.getColumn(1).alignment = {
          wrapText: true,
          horizontal: "left",
        };
        worksheet.getColumn(2).alignment = {
          wrapText: true,
          horizontal: "right",
        };
        worksheet.getColumn(4).alignment = {
          wrapText: true,
          horizontal: "right",
        };
        worksheet.getColumn(9).alignment = {
          wrapText: true,
          horizontal: "center",
        };
        worksheet.getColumn(13).alignment = {
          wrapText: true,
          horizontal: "right",
        };
        worksheet.getColumn(14).alignment = {
          wrapText: true,
          horizontal: "right",
        };
        worksheet.getColumn(11).alignment = {
          wrapText: true,
          horizontal: "right",
        };

        worksheet.addRow([]);
        worksheet.mergeCells("B2:C2");
        worksheet.mergeCells("B4:C4");
        worksheet.getCell("B2").alignment = { horizontal: "left" };
        worksheet.getCell("B3").alignment = { horizontal: "left" };
        worksheet.getCell("B4").alignment = { horizontal: "left" };
        worksheet.getCell("H5").alignment = { horizontal: "center" };
        worksheet.getCell("E5").alignment = { horizontal: "center" };
        worksheet.getCell("B5").alignment = { horizontal: "center" };
        worksheet.getCell("D5").alignment = { horizontal: "center" };
        worksheet.getCell("M5").alignment = { horizontal: "center" };
        worksheet.getCell("N5").alignment = { horizontal: "center" };
        worksheet.getCell("K5").alignment = { horizontal: "center" };
        worksheet.getCell("I5").alignment = { horizontal: "center" };

        const userName = this.userName;
        const now = new Date();
        masks.hammerTime = "dd/mm/yyyy HH:MM";
        let footerRow = worksheet.addRow([
          "Date : " + dateFormat(now, "hammerTime"),
        ]);
        let sidecoloum = worksheet.addRow([`User Name: ${userName}`]);
        worksheet.addRow([]);
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fs.saveAs(blob, "Spares History.xlsx");
        });
      });
  }
  // generateExcel() {
  //   console.log("excel,,,,,")
  //   const title = ["","","", "         Spares History ", "", ""];
  //   let header = [];
  //   header = [
  //     "                  MR Number",
  //     "                MR Date & Time              ",
  //     "                     WO Number            ",
  //     "                WO Date & Time              ",
  //     // "                   Item Code               ",
  //     // "                   Item Description",
  //     // "            Quantity",
  //     // "              Issue to",
  //     // "                Issue Cost    ",
  //     // "            PR Number",
  //     // "                PR Date & Time              ",
  //     // "               PO Number",
  //     // "                PO Date & Time              ",
  //     // "                GRN Date & Time              ",
  //     // "                   Supplier Name              "
  //   ];
  //   let datas = [];
  //   let index = 1;
  //   this.sparesHistoryData.forEach(data => {
  //     // console.log("this.benumbernew",this.benumbernew)
  //     datas.push(
  //       [(data.mrNumber || 'NA'),
  //         // (dateFormat(data.woDateTime, "dd/mm/yyyy HH:mm:ss")),
  //         (data.mrDateTime ? dateFormat(data.mrDateTime, "dd/mm/yyyy HH:mm:ss") : 'NA'),
  //         (data.woNumber || 'NA'),
  //         (data.woDateTime ? dateFormat(data.woDateTime, "dd/mm/yyyy HH:mm:ss") : 'NA')],

  //       //   (data.stockCode || 'NA'),
  //       // (data.stockDescription || 'NA'),
  //       // (data?.issueQuantity ? data?.issueQuantity : (data?.issuedQty ? data?.issuedQty : 'NA')),

  //       // (data?.ppmIssueTo ? data?.ppmIssueTo : (data?.bdmIssueTo ? data?.bdmIssueTo : (data?.issueTo ? data?.issueTo : 'NA'))),
  //       // (data.issueCost || 'NA'),
  //       // (data.prNumber || 'NA'),
  //       // (data.prDate ? dateFormat(data.prDate, "dd/mm/yyyy HH:MM:ss") : 'NA'),

  //       // (data.poNumber || 'NA'),
  //     //  (dateFormat(data.poDateTime,"dd/mm/yyyy HH:mm:ss")),
  //     //  (data.poDateTime ? dateFormat(data.poDateTime, "dd/mm/yyyy HH:MM:ss") : 'NA'),

  //     //  (dateFormat(data.grndateTime, "dd/mm/yyyy HH:mm:ss")),
  //     //  (data.grndateTime ? dateFormat(data.grndateTime, "dd/mm/yyyy HH:MM:ss") : 'NA'),

  //     //  (data.supplierName || 'NA')]
  //       //   [(data.woNumber), (dateFormat(data.woDateTime, "dd/mm/yyyy HH:mm:ss")), (data.mrNumber), (dateFormat(data.mrDateTime, "dd/mm/yyyy HH:mm:ss")),(data.stockCode),
  //       //   // (data.stockDescription)
  //       //   (data.stockDescOld)
  //       //   , (data.issueQuantity), (data.issueTo), (data.issueCost),(data.prNumber),
  //       // (dateFormat(data.prDate, "dd/mm/yyyy HH:mm:ss")), (data.poNumber),(dateFormat(data.poDateTime,"dd/mm/yyyy HH:mm:ss")), (dateFormat(data.grnDateTime, "dd/mm/yyyy HH:mm:ss")),(data.supplierName)]

  //     )
  //     index++
  // })
  //   let workbook = new Workbook();
  //   let worksheet = workbook.addWorksheet("Spares History");
  //   // worksheet.addRow([]);
  //   let titleRow = worksheet.addRow(title);
  //   worksheet.addRow(['State : ' + this.beNumberData?.assetLocation.district.stateName,'','','','', 'Clinic Name : ' + this.beNumberData?.assetLocation?.clinic?.clinicName]).font ={
  //     bold: true
  //   };
  //   worksheet.addRow(['Circle : ' + this.beNumberData?.assetLocation.district.circleName,'','','','', 'Be Number: ' + this.beNumberData?.beNumber]).font ={
  //     bold: true
  //   };
  //   // worksheet.addRow([]);
  //   worksheet.addRow(['District : ' +this.beNumberData?.assetLocation.district.districtName, '','','','','Be Category: ' + this.beNumberData?.assetDescription?.assetCategory?.beCategoryName]).font ={
  //     bold: true
  //   };
  //   // worksheet.addRow([]);
  //   titleRow.font = {
  //     size: 14,
  //     bold: true,
  //   };

  //   const columnWidths =[

  //     15,  // Adjust the width for "WO Number"
  //     20,  // Adjust the width for "WO Date & Time"
  //     15,  // Adjust the width for "MR No"
  //     20,  // Adjust the width for "MR Date & Time"
  //     30,  // Adjust the width for "Item Code"
  //     25,  // Adjust the width for "Item Description"
  //     10,  // Adjust the width for "Quantity"
  //     15,  // Adjust the width for "Issue to"
  //     15,  // Adjust the width for "Issue Cost"
  //     15,  // Adjust the width for "PR Number"
  //     20,  // Adjust the width for "PR Date & Time"
  //     15,  // Adjust the width for "PO Number"
  //     20,  // Adjust the width for "PO Date & Time"
  //     20,  // Adjust the width for "GRN Date & Time"
  //     25   // Adjust the width for "Supplier Name"
  //   ];
  //   console.log("header",header)

  //   header.forEach((headerText, columnIndex) => {
  //     const cell = worksheet.getCell(5, columnIndex + 1); // Assuming header row is the first row (row 1)
  //     // worksheet.addRow([]);
  //     cell.value = headerText;
  //     cell.alignment = { horizontal: 'center' };
  //     cell.font={
  //       size: 11,
  //         bold: true,
  //     };
  //     worksheet.getColumn(columnIndex + 1).width = columnWidths[columnIndex];
  //   });

  //   // let headerRow = worksheet.addRow(header);
  //   // headerRow.font = {
  //   //   size: 11,
  //   //   bold: true,
  //   // };
  //   // headerRow.eachCell((cell) => {
  //   //   cell.alignment = {
  //   //     horizontal: "center",
  //   //     // vertical: "middle",
  //   //   };
  //   // });
  //   // headerRow.alignment = {
  //   //   horizontal: "center", // Center-align the header cells
  //   // };

  //   // worksheet.mergeCells('A1:A1');
  //   // worksheet.mergeCells('B1:B1');
  //   // worksheet.mergeCells('C1:C1');
  //   // worksheet.mergeCells("D3:D3");
  //   // worksheet.getCell('D3').alignment = {
  //   //   vertical: 'middle',
  //   //   horizontal: 'center',
  //   // }
  //   // worksheet.addRow([]);
  //   // headerRow.eachCell((cell, number) => {
  //   //   cell.border = {
  //   //     top: { style: "thin" },
  //   //     left: { style: "thin" },
  //   //     bottom: { style: "thin" },
  //   //     right: { style: "thin" },

  //   //   };
  //   // });
  //   console.log("datas",datas)
  //   datas.forEach((d) => {

  //     let row = worksheet.addRow(d);
  //     row.eachCell((cell) => {
  //       cell.border = {
  //         top: { style: "thin" },
  //         left: { style: "thin" },
  //         bottom: { style: "thin" },
  //         right: { style: "thin" },
  //       };

  //     });
  //   });
  //   worksheet.getColumn(1).width = 30;
  //   worksheet.getColumn(2).width = 40;
  //   worksheet.getColumn(3).width = 30;
  //   worksheet.getColumn(4).width = 40;
  //   worksheet.getColumn(5).width = 30;
  //   worksheet.getColumn(6).width = 40;
  //   worksheet.getColumn(7).width = 10;
  //   worksheet.getColumn(8).width = 20;
  //   worksheet.getColumn(9).width = 20;
  //   worksheet.getColumn(10).width = 20;
  //   worksheet.getColumn(11).width = 20;
  //   worksheet.getColumn(12).width = 20;
  //   worksheet.getColumn(13).width = 20;
  //   worksheet.getColumn(14).width = 40;
  //   worksheet.getColumn(15).width = 30;
  //   worksheet.getColumn(7).alignment = { wrapText: true, horizontal:'center', }
  //   worksheet.getColumn(1).alignment = { wrapText: true, horizontal:'left', }
  //   worksheet.getColumn(2).alignment = { wrapText: true, horizontal:'right', }
  //   worksheet.getColumn(4).alignment = { wrapText: true, horizontal:'right', }
  //   worksheet.getColumn(9).alignment = { wrapText: true, horizontal:'center', }
  //   worksheet.getColumn(13).alignment = { wrapText: true, horizontal:'right', }
  //   worksheet.getColumn(14).alignment = { wrapText: true, horizontal:'right', }
  //   worksheet.getColumn(11).alignment = { wrapText: true, horizontal:'right', }
  //   // worksheet.getColumn(15).alignment = { wrapText: true, horizontal:'right', }
  //   worksheet.addRow([]);
  //   worksheet.mergeCells('B2:C2');
  //   worksheet.mergeCells('B4:C4');
  //   worksheet.getCell('B2').alignment = {
  //     horizontal: "left", // Center-align the specific cell
  //   };
  //   worksheet.getCell('B3').alignment = {
  //     horizontal: "left", // Center-align the specific cell
  //   };worksheet.getCell('B4').alignment = {
  //     horizontal: "left", // Center-align the specific cell
  //   };
  // worksheet.getCell('H5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('E5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('B5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('D5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('M5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('N5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('K5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('E5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   worksheet.getCell('I5').alignment = {
  //     horizontal: "center", // Center-align the specific cell
  //   };
  //   // headerRow.getCell(15).alignment = {
  //   //   horizontal: "center", // Center-align the specific cell
  //   // };
  //   // headerRow.getCell(15).alignment = {
  //   //   horizontal: "center", // Center-align the specific cell
  //   // };

  //   const userName = this.userName
  //   const now = new Date();
  //   masks.hammerTime = 'dd/mm/yyyy HH:MM';
  //   let footerRow = worksheet.addRow([
  //     "Date : " + dateFormat(now, "hammerTime"),
  //   ]);
  //   let sidecoloum = worksheet.addRow([`User Name: ${userName}`  ]);
  //   worksheet.addRow([]);
  //   // worksheet.mergeCells(`A${footerRow.number}:C${footerRow.number}`);
  //   // worksheet.mergeCells(`A${sidecoloum.number}:C${sidecoloum.number}`);
  //   // if (this.dataList.length > 0) {
  //     workbook.xlsx.writeBuffer().then((data) => {
  //       let blob = new Blob([data], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       fs.saveAs(blob, "Spares History.xlsx");
  //     });
  //   // }
  // }
  openMaintenance() {
    this.buttonFlag = 1;
    this.maintenanceInfo = true;
    this.dateInfo = true;
    this.rentalInfo = false;
    this.purchaseInfo = false;
    this.statutoryInfo = false;
  }
  openDate() {
    this.buttonFlag = 1;
    this.dateInfo = true;
    this.maintenanceInfo = true;
    this.rentalInfo = false;
    this.purchaseInfo = false;
    this.statutoryInfo = false;
  }
  openRental() {
    this.buttonFlag = 4;
    this.rentalInfo = true;
    this.maintenanceInfo = false;
    this.dateInfo = false;
    this.purchaseInfo = false;
    this.statutoryInfo = false;
  }
  openPurchase() {
    this.buttonFlag = 3;
    this.purchaseInfo = true;
    this.maintenanceInfo = false;
    this.dateInfo = false;
    this.rentalInfo = false;
    this.statutoryInfo = true;
  }
  openStatutory() {
    this.buttonFlag = 3;
    this.statutoryInfo = true;
    this.maintenanceInfo = false;
    this.dateInfo = false;
    this.rentalInfo = false;
    this.purchaseInfo = true;
  }
  //   openCity(event, cityName) {
  //     var i, tabcontent, tablinks;
  //     tabcontent = document.getElementsByClassName("tabcontent");
  //     for (i = 0; i < tabcontent.length; i++) {
  //         tabcontent[i].style.display = "none";
  //     }
  //     tablinks = document.getElementsByClassName("tablinks");
  //     for (i = 0; i < tablinks.length; i++) {
  //         tablinks[i].className = tablinks[i].className.replace("active", "");
  //     }
  //     console.log('dom',document.getElementById)
  //     document.getElementById(cityName).style.display = "block";
  //     event.currentTarget.className += "active";
  // }
  buttonFlag: any = 1;
  fileNotAvailable() {
    this.toasterService.error("Supporting Document", "Not Available", {
      timeOut: 3000,
    });
  }
  conditionalCheck() {
    if (this.beNumberData?.assetDescription?.ownershipId == 1) {
      return (
        this.fileChecing?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "serviceNotificationFormFile"
        )?.id == undefined
      );
    } else {
      return (
        this.fileChecingInt?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "Kewpa15File"
        )?.id == undefined
      );
    }
  }
  locationCheck() {
    if (this.beNumberData?.assetDescription?.ownershipId == 1) {
      return (
        this.fileChecingtwo?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "varVs4File"
        )?.id == undefined
      );
    } else {
      return (
        this.fileChecingtwoInt?.multipleFileUpload.find(
          (obj) => obj?.fileKey == "InternalVariationV1S4SupportingDocument"
        )?.id == undefined
      );
    }
  }
  conditionalCheckInternal() {
    return (
      this.fileChecingInt?.multipleFileUpload.find(
        (obj) => obj?.fileKey == "Kewpa15File"
      )?.id == undefined
    );
  }
  locationCheckInternal() {
    return (
      this.fileChecingtwoInt?.multipleFileUpload.find(
        (obj) => obj?.fileKey == "InternalVariationV1S4SupportingDocument"
      )?.id == undefined
    );
  }
  // createTableRow(data) {
  //   return [data[0]];
  // }
  beNumberInfoOld(data){
    console.log('wat goes',data)
    this.cardVisibility = false;
    setTimeout(() => {
    this.beNumber = data.oldBeNumber
    // set all the values..
    // console.log('chk',this.beNumber)
    console.log("chk1", this.cardVisibility)
    this.cardVisibility = true;}, 10);
  }
  beNumberInfoNew(data){
    console.log('wat goes',data)
    this.cardVisibility = false;
    setTimeout(() => {
    this.beNumber = data.newBeNumber
    // set all the values..
    // console.log('chk',this.beNumber)
    console.log("chk1", this.cardVisibility)
    this.cardVisibility = true;}, 10);
  }
  conditionalDocument:any
  downloadConditionalDocument(data: any, event: Event) {
    event.preventDefault(); // Prevent default link behavior
  
    this.amdService.downloadFileForConditionalChange(data.fileId,data.fileKey
     
    ).subscribe(
        (response: Blob) => {
            // Store response in FormB14 (assuming it's a Blob or File URL)
            this.conditionalDocument = response;
  
            // Trigger the download
            this.triggerDownloadConditional();
        },
        (error: any) => {
            if (error.status === 200) {
                this.conditionalDocument = error.url; // Store direct URL
                this.triggerDownloadConditional(); // Trigger download
            } else {
                console.error('Download failed', error);
                this.toasterService.error("Not Available","Supporting Document", {
                  timeOut: 3000,
                });
            }
        }
    );
  }
  triggerDownloadConditional() {
    if (!this.conditionalDocument) {
        console.error('No file to download');
        this.toasterService.error("Not Available","Supporting Document", {
          timeOut: 3000,
        });
        return;
    }
  
    let downloadUrl: string;
  
    if (typeof this.conditionalDocument === 'string') {
        // If FormB14 is a URL, use it directly
        downloadUrl = this.conditionalDocument;
    } else {
        // If FormB14 is a Blob, create a URL from it
        const blob = new Blob([this.conditionalDocument], { type: 'application/pdf' }); // Adjust type as needed
        downloadUrl = window.URL.createObjectURL(blob);
    }
  
    // Create an anchor tag and trigger download
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = 'ConditionalDocument.pdf'; // Set filename
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  
    // Cleanup if it's a blob URL
    if (typeof this.conditionalDocument !== 'string') {
        window.URL.revokeObjectURL(downloadUrl);
    }
  }
  locationDocument:any
  downloadLocationDocument(data: any, event: Event) {
    event.preventDefault(); // Prevent default link behavior
  
    this.amdService.downloadFileForConditionalChange(data.oldFileId,data.oldFileKey
     
    ).subscribe(
        (response: Blob) => {
            // Store response in FormB14 (assuming it's a Blob or File URL)
            this.locationDocument = response;
  
            // Trigger the download
            this.triggerDownloadLocation();
        },
        (error: any) => {
            if (error.status === 200) {
                this.locationDocument = error.url; // Store direct URL
                this.triggerDownloadLocation(); // Trigger download
            } else {
                console.error('Download failed', error);
                this.toasterService.error("Not Available","Supporting Document", {
                  timeOut: 3000,
                });
            }
        }
    );
  }
  triggerDownloadLocation() {
    if (!this.locationDocument) {
        console.error('No file to download');
        this.toasterService.error("Not Available","Supporting Document", {
          timeOut: 3000,
        });
        return;
    }
  
    let downloadUrl: string;
  
    if (typeof this.locationDocument === 'string') {
        // If FormB14 is a URL, use it directly
        downloadUrl = this.locationDocument;
    } else {
        // If FormB14 is a Blob, create a URL from it
        const blob = new Blob([this.locationDocument], { type: 'application/pdf' }); // Adjust type as needed
        downloadUrl = window.URL.createObjectURL(blob);
    }
  
    // Create an anchor tag and trigger download
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = 'LocationDocument.pdf'; // Set filename
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  
    // Cleanup if it's a blob URL
    if (typeof this.locationDocument !== 'string') {
        window.URL.revokeObjectURL(downloadUrl);
    }
  }
}
